// extracted by mini-css-extract-plugin
module.exports = {"location-container--header":"lEfd8","body":"o0MS8","body-art":"MwsNl","rc-tabs-bar":"mIqNB","rc-tabs-tab":"-sAVZ","rc-tabs-tab-active":"EvcNc","invalidItem":"_6Ur69"};